import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { Url, Utilities } from 'src/app/common';
import { User, UserAuth } from 'src/app/common/user-auth';
import { ConfirmDialogService } from '../services/confirm-dialog.component';
import { LayoutService } from '../services/layout.service';
import { Deputy } from '../models/deputy';
import { deputyColumns } from '../models/deputy-columns.model';
import { WindowService } from '@progress/kendo-angular-dialog';
import { DebutyComponent } from './deputy.component';

@Component({
  selector: 'app-user-notification-deputy-list',
  templateUrl: '../views/deputy-list.component.html',
  styleUrls: ['../styles/style.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DebutyListComponent implements OnInit {
  userAuth: User = UserAuth.get();
  url = Url;
  @Output() public formClosed: EventEmitter<any> = new EventEmitter();
  deputyList: Array<Deputy> = [];
  gridColumns = deputyColumns;
  employees = [];

  constructor(
    public layoutService: LayoutService,
    private windowService: WindowService,
    public confirmDialogService: ConfirmDialogService,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnInit() {
    this.getDeputies();

  }

  getDeputies() {
    this.layoutService.getDeputies(this.userAuth.id).subscribe((response) => {
      if (response.Status == 200) {
        Utilities.parseToDateObject(
          response.Deputies,
          deputyColumns.filter((a) => a.filter == 'date')
        );

        this.deputyList = response.Deputies;
      }
    });
  }

  openDeputyModal(id) {
    const windowRef = this.windowService.open({
      title: 'Stellvertretung bearbeiten',
      content: DebutyComponent,
      width: 1200,
      appendTo: this.viewContainerRef,
      top: 200,
    });

    windowRef.result.subscribe((result) => {});

    let notificationsComponent: DebutyComponent = windowRef.content.instance as DebutyComponent;
    
    notificationsComponent.id=id;
    notificationsComponent.formClosed.subscribe((formData) => {
      this.getDeputies();
      windowRef.close();
    });
  }

  onDblClick(deputy) {
    this.openDeputyModal(deputy.id);
  }

  closeDialog() {
    this.formClosed.next({});
  }
}
